import React from "react";
import { useState } from "react";
import { addParamUrl } from "../../../../utils";
import { GroupSpecialGochiKidDetailModal } from "./GroupSpecialGochiKidDetailModal";
import GochiService from "../../../../api/services/GochiService";
import moment from "moment";
import { GochiKidGroupNoteModal } from "./GochiKidGroupNoteModal";
import { GOCHI_KID_GROUP_NAME_HAS_NOTE } from "../../../../constants";

export function GroupSpecialGochiKidModal(props) {
  const [groupSpecialDetail, setGroupSpecialDetail] = useState(null);
  const [groupSpecialImage, setGroupSpecialImage] = useState({});
  const [showGroupSpecialDetailModal, setShowGroupSpecialDetailModal] =
    useState(false);
  const [showGochiKidGroupNoteModal, setShowGochiKidGroupNoteModal] =
    useState(false);
  const accessTokenParam = props.accessToken
    ? { name: "accessToken", value: props.accessToken }
    : {};
  const accessCodeParam = props.accessCode
    ? { name: "accessCode", value: props.accessCode }
    : {};

  function checkConditionSubmit() {
    const groupChoice = props.listGroupSpecialGochiKid?.filter(
      (group) => group.gochiKidGroupId === props.gochiKidGroupId
    );

    if (
      groupChoice?.length > 0 &&
      groupChoice[0] &&
      groupChoice[0].gochiKidGroupName === GOCHI_KID_GROUP_NAME_HAS_NOTE
    ) {
      setShowGochiKidGroupNoteModal(true);
    } else {
      handleSubmit();
    }
  }

  function handleSubmit() {
    document
      .getElementsByTagName("html")[0]
      .classList.remove("hide-scroll-background-gochi-kid");
    if (props.gochiKidGroupId) {
      if (props.shopIdGochiKidQr && props.accessToken && props.accessCode) {
        window.location.href = addParamUrl(
          `/mypage/kodomo_use/search_shop/${props.shopIdGochiKidQr}?gochiKidGroupId=${props.gochiKidGroupId}`,
          [props.isSiteParam, accessTokenParam, accessCodeParam]
        );
      } else {
        window.location.href = addParamUrl(
          `/mypage/kodomo_use/search_shop?gochiKidGroupId=${props.gochiKidGroupId}`,
          [props.isSiteParam]
        );
      }
    } else {
      if (props.shopIdGochiKidQr && props.accessToken && props.accessCode) {
        window.location.href = addParamUrl(
          `/mypage/kodomo_use/search_shop/${props.shopIdGochiKidQr}?accessToken=${props.accessToken}&accessCode=${props.accessCode}`,
          [props.isSiteParam]
        );
      } else {
        window.location.href = addParamUrl(`/mypage/kodomo_use/search_shop`, [
          props.isSiteParam,
        ]);
      }
    }
  }

  async function handleShowGroupSpecialDetail(group) {
    setGroupSpecialDetail(group);
    if (group) {
      const data = await GochiService.getSponsorGochiKidGroupSpecial(
        group.gochiKidGroupId,
        props.accessToken,
        null
      );
      if (data.status === 200) {
        setGroupSpecialImage(data.data);
      }
    } else {
      setGroupSpecialImage({});
    }
    setShowGroupSpecialDetailModal(true);
  }

  return (
    <>
      <div
        className={
          props.showing
            ? "custom-modal-container group-special-gochi-kid-modal show-modal"
            : "custom-modal-container group-special-gochi-kid-modal"
        }
        size="sm"
      >
        <div
          className={
            props.showing
              ? "modal modal-action modal-dialog is-show history-modal max-width-335"
              : "modal modal-action modal-dialog history-modal max-width-335"
          }
        >
          <div className="modal-header-history">
            {!(props.accessToken || props.accessCode) && (
              <button
                className="modal-btn modal-btn-close"
                id="modalClose"
                onClick={() => props.handleClose()}
                type="button"
              >
                <svg className="icon">
                  <title>閉じる</title>
                  <use xlinkHref="/assets/img/common/icon.svg#times" />
                </svg>
              </button>
            )}
          </div>
          <div className="title-modal title-modal-charge">
            <div className="title">支援元を選ぶ</div>
          </div>
          <div className={`modal-body`}>
            {props.listGroupSpecialGochiKid?.length > 0 ?
              (props.listGroupSpecialGochiKid?.map((item, index) => {
                return (
                  <div
                    className={`group-special-box ${
                      index < props.listGroupSpecialGochiKid?.length - 1
                        ? "mb-24px"
                        : ""
                    }`}
                    key={item.gochiKidGroupId}
                  >
                    <div className="field-radio radio-box">
                      <label className="radio-group-special">
                        <input
                          className="before-icon"
                          name="poorStatus"
                          type="radio"
                          checked={
                            props.gochiKidGroupId === item.gochiKidGroupId
                          }
                          value={item.gochiKidGroupId}
                          onChange={(e) => {
                            props.setGochiKidGroupId(parseInt(e.target.value));
                          }}
                        />
                        <i className="icon" />
                      </label>
                    </div>
                    <div className="group-special-info">
                      <div className="group-special-title">
                        <span>「</span>
                        <span
                          className="group-special-name"
                          onClick={() => handleShowGroupSpecialDetail(item)}
                        >
                          {item.gochiKidGroupName}
                        </span>
                        <span>」</span>
                        <span>を利用する</span>
                      </div>
                      <table className="gochi-kid-group-info-table">
                        <tbody>
                          <tr>
                            <td className="title">利用可能食数</td>
                            <td className="text">
                              {item.numberSlotCanUse <= 1000
                                ? item.numberSlotCanUse
                                : "1000+"}
                              食
                            </td>
                          </tr>
                          {item.endTime && (
                            <>
                              <tr>
                                <td className="title pt-4px">利用受付終了</td>
                                <td className="text pt-4px">
                                  {moment(item.endTime).format(
                                    "YYYY年MM月DD日"
                                  )}
                                </td>
                              </tr>
                              <tr>
                                <td className="title">日時</td>
                                <td className="text">
                                  {moment(item.endTime).format("HH:mm:ss")}
                                </td>
                              </tr>
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                );
              })) : (
                <div>データがありません。</div>
              )}
            <div
              className={`history-load-more ${
                props.loadingListGroupSpecialGochiKid
                  ? "text-decoration-none"
                  : ""
              }`}
            >
              {props.listGroupSpecialGochiKid.length <
                props.totalGroupSpecialGochiKid && (
                <span
                  className={`cursor-pointer fs-15 align-center ${
                    props.loadingListGroupSpecialGochiKid ? "loading" : ""
                  }`}
                  onClick={() => props.loadMore(props.shopIdGochiKidQr)}
                >
                  ▼ もっと見る
                </span>
              )}
            </div>
            {props.listGroupSpecialGochiKid?.length > 0 && (
              <div className="modal-footer">
                <button
                  onClick={() => checkConditionSubmit()}
                  id="submitConfirm"
                  className="btn btn-rect btn-submit"
                >
                  選択して次に進む
                </button>
              </div>
            )}
          </div>
        </div>
        <div
          onClick={() => props.handleClose()}
          className={`back-drop ${
            props.accessToken && props.accessCode ? "back-drop-bold" : ""
          }`}
        />
      </div>

      <GroupSpecialGochiKidDetailModal
        showing={showGroupSpecialDetailModal}
        handleClose={() => {
          setShowGroupSpecialDetailModal(false);
        }}
        groupSpecialDetail={groupSpecialDetail}
        groupSpecialImage={groupSpecialImage}
      />

      <GochiKidGroupNoteModal
        showing={showGochiKidGroupNoteModal}
        handleSubmit={handleSubmit}
        setShowGochiKidGroupNoteModal={setShowGochiKidGroupNoteModal}
      />
    </>
  );
}
